import React from 'react'
import './StartBtn.css'
import Button from '@mui/material/Button';


const StartBtn = (props) => {
    return (
        <div>
           <Button id="startbtn" variant="contained" onClick={() => {props.setStart(true)}}>Start</Button> 
        </div>
    )
}

export default StartBtn
